import React from 'react'
import styles from './FirmwareUpdateDialog.module.css'

const DeviceMismatchDialog = ({
    isOpen,
    title = 'Device mismatch found',
    selectedLabel,
    connectedLabel,
    message = 'Would you like to continue with the connected device?',
    onAccept,
    onClose,
    showAccept = true,
}) => {
    if (!isOpen) return null

    return (
        <div className={styles.overlay}>
            <div className={styles.modal}>
                <button
                    aria-label="Close"
                    className={styles.closeButton}
                    onClick={onClose}
                />
                <div className={styles.header}>
                    <h2>{title}</h2>
                </div>

                <div className={styles.content}>
                    <div className={styles.deviceInfo}>
                        <div className={styles.versionComparison}>
                            <div className={styles.versionBox}>
                                <span className={styles.versionLabel}>
                                    Selected
                                </span>
                                <span className={styles.versionNumber}>
                                    {selectedLabel}
                                </span>
                            </div>
                            <div className={styles.arrow}>→</div>
                            <div className={styles.versionBox}>
                                <span className={styles.versionLabel}>
                                    Connected
                                </span>
                                <span
                                    className={
                                        styles.versionNumber +
                                        ' ' +
                                        styles.latest
                                    }
                                >
                                    {connectedLabel}
                                </span>
                            </div>
                        </div>
                    </div>

                    <div className={styles.message}>
                        <p>{message}</p>
                    </div>

                    {showAccept && (
                        <div className={styles.actions}>
                            <button
                                className={styles.updateButton}
                                onClick={onAccept}
                            >
                                YES
                            </button>
                        </div>
                    )}
                </div>
            </div>
        </div>
    )
}

export default DeviceMismatchDialog
